import { render, staticRenderFns } from "./InsuranceItem.vue?vue&type=template&id=cb771e0e"
import script from "./InsuranceItem.vue?vue&type=script&lang=js"
export * from "./InsuranceItem.vue?vue&type=script&lang=js"
import style0 from "./InsuranceItem.vue?vue&type=style&index=0&id=cb771e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports